export default __webpack_public_path__ + "static/media/download-remote.7fe73c8d.svg";